<template>
  <v-dialog
      v-bind="$props"
      v-model="dialog"
      persistent
      content-class="b-dialog"
  >
    <v-card class="b-dialog-card">
      <v-card-title>
        <slot name="title-wrapper">
          <h2>
            <slot name="title">Achtung!</slot>
          </h2>
        </slot>
      </v-card-title>
      <v-card-text>
        <slot name="content-wrapper">
          <span>
            <slot name="content"></slot>
          </span>
        </slot>
      </v-card-text>
      <v-card-actions class="b-dialog-actions">
        <v-row class="justify-end">
          <slot name="dialog-actions">
            <v-col>
              <slot name="accept-action">
                <b-btn @click="triggerResolve" block>
                  <slot name="accept-action-text">
                    Übernehmen
                  </slot>
                </b-btn>
              </slot>
            </v-col>
            <v-col>
              <slot name="abort-action">
                <b-btn @click="close" block>
                  <slot name="abort-action-text">
                    Abbrechen
                  </slot>
                </b-btn>
              </slot>
            </v-col>
          </slot>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {VTextField} from 'vuetify/lib';

export default {
  name: "BBasicDialog",
  props: {
    ...VTextField.options.props,
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    open() {
      this.dialog = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    triggerResolve(value) {
      this.close();
      this.resolve(value);
    },
    triggerReject(value) {
      this.close();
      this.reject(value);
    },
    close() {
      this.dialog = false;
    },
  },
}
</script>

<style lang="scss" scoped>
@import './src/styles/dialog.scss';
</style>
